/**
 * Endpoint methods related to Signup Forms
*/

import API from "./Api";

export default {
  /**
   * Gets Signup Forms related to the logged-In instance
  */
  async getForms() {

    return API.get("/signup-forms/read", "COOKIE_TOKEN_SESSION");
  },

  /**
   * Gets an individual Signup Form related to the GUID
  */
  async getFormByGuid(guid) {
    return API.get(`/forms/${guid}`, {});
  },

  /**
   * Creates a Signup Form
  */
  async createForm(body){

    return API.post("/signup-forms/create", body,"MOODLE_SESSION_JSON");
  },

  /**
   * Updates a Signup Form
  */
  async updateForm(body){

    return API.post("/signup-forms/update", body, "MOODLE_SESSION_JSON");
  },

  /**
   * Deletes a Signup Form
  */
  async deleteForm(id){

    const body = {
      form_id: id
    }
    return API.post("/signup-forms/delete", body, "MOODLE_SESSION_JSON");
  }
};
